/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Link, useNavigate } from "react-router-dom";
import { evWhereMemberState, loadingState, userInfoState } from "../../../recoil/atoms";
import { Div, Font } from "../../../styles/commonStyle";
import { cardTitleColor2 } from "../../../styles/theme";
import { Flex, LinkAccountSection, RoundButton } from "../style";
import { Highlight, InfoContent, InfoItem, InfoList } from "./style";

function LinkAccountCompletePage() {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useRecoilState(loadingState);
    const [evWhereMember, setEvWhereMember] = useRecoilState(evWhereMemberState);
    const [userInfo, setUserInfo] = useRecoilState(userInfoState);

    return (
        <>
            <Font fontSize="1.75rem" fontWeight="500" color={cardTitleColor2} changeFontSize="20px">
                회원 통합 완료
            </Font>
            <LinkAccountSection margin="30px 0 100px 0" padding="70px 20px">
                <Flex flexDirection="column">
                    <Font fontSize="1.25rem" fontWeight="500" color={cardTitleColor2} changeFontSize="18px">아래의 회원 정보로 통합회원 전환이 완료되었습니다.</Font>
                    <Div style={{ width: "100%", maxWidth: "600px", backgroundColor: "#f4f4f4", padding: "60px 30px", borderRadius: "6px", marginTop: "30px" }}>
                        <InfoList>
                            <InfoItem>
                                <Highlight>• 아이디</Highlight>
                                <InfoContent>{userInfo?.lgnId}</InfoContent>
                            </InfoItem>
                            <InfoItem>
                                <Highlight>• 이름</Highlight>
                                <InfoContent>{userInfo?.nm}</InfoContent>
                            </InfoItem>
                            <InfoItem>
                                <Highlight>• 휴대폰번호</Highlight>
                                <InfoContent>{userInfo?.phone}</InfoContent>
                            </InfoItem>
                            <InfoItem>
                                <Highlight>• 이메일</Highlight>
                                <InfoContent>{userInfo?.email}</InfoContent>
                            </InfoItem>
                            <InfoItem>
                                <Highlight>• 결제카드 정보</Highlight>
                                {(() => {
                                    const paycardData = userInfo?.paycardData;
                                    if (Array.isArray(paycardData)) {
                                        return <InfoContent>[{paycardData[0]?.paycardCo}] {paycardData[0]?.paycardNo}</InfoContent>;
                                    } else {
                                        return <InfoContent>[{paycardData?.paycardCo}] {paycardData?.paycardNo}</InfoContent>;
                                    }
                                })()}
                            </InfoItem>
                            {(!evWhereMember?.ssbyp) || (evWhereMember?.ssbyp != 'email') && (
                                <InfoItem>
                                    <Highlight>• SNS 로그인 연동</Highlight>
                                    <InfoContent>{evWhereMember?.ssbyp ?? '-'}</InfoContent>
                                </InfoItem>
                            )}
                            {
                                userInfo?.adres && (
                                    <InfoItem>
                                        <Highlight>• 배송지 주소</Highlight>
                                        <InfoContent>{userInfo?.adres}</InfoContent>
                                    </InfoItem>
                                )
                            }
                            {
                                userInfo?.adresDetail && (
                                    <InfoItem>
                                        <Highlight>• 배송지 상세 주소</Highlight>
                                        <InfoContent>{userInfo?.adresDetail}</InfoContent>
                                    </InfoItem>
                                )
                            }
                        </InfoList>
                    </Div>
                    <Div style={{ textAlign: "center", marginTop: "50px" }}>
                        <RoundButton
                            width="300px"
                            fontSize="1rem"
                            height="46px"
                            borderRadius="30px"
                            onClick={() => {
                                setEvWhereMember(undefined);
                                navigate("/login");
                            }}
                        >로그인 화면으로 이동</RoundButton>
                    </Div>
                </Flex>

            </LinkAccountSection>
        </>
    );
}

export default LinkAccountCompletePage;
